// 方法
import { accAdd } from "../../../utils/dataUtils";
// 常量
import { ITotalItem } from "../../../SuperTable/subpage/tableTotal";

/**
 * 生成统计数据
 * @param totalKeys 统计字段配置
 * @param dataSource 可编辑表数据
 * @returns 
 */
export function getTotalInfo(
  totalKeys?: ITotalItem[],
  dataSource?: any[],
): any {
  let totalData: any = {};
  if (Array.isArray(totalKeys) && Array.isArray(dataSource)) {
    totalKeys.forEach(item => {
      const { dataIndex, format } = item;
      const currentValue = dataIndexTotal(dataIndex, dataSource);
      totalData[dataIndex] = format ? format(currentValue) : currentValue;
    });
  }
  return totalData;
}
/**
 * 根据字段名求和
 * @param dataIndex 字段名
 * @param dataSource 可编辑表数据
 * @returns 
 */
export function dataIndexTotal(dataIndex: string, dataSource: any[]): number {
  let total: number = 0;
  dataSource.forEach(item => {
    const children = item.children;
    if (Array.isArray(children)) {
      const childrenTotal = dataIndexTotal(dataIndex, children);
      total = accAdd(total, childrenTotal);
    }
    if (item[dataIndex]) {
      total = accAdd(total, Number(item[dataIndex]) || 0);
    }
  });
  return total;
}